import { createSlice } from "@reduxjs/toolkit";

const savingsSlice = createSlice({
  name: "savingsReducer",
  initialState: {
    mySavings: {},
  },
  reducers: {
    setSavings: (state, action) => {
      const { payload } = action;
      state.mySavings = payload;
    },
  },
});

export const {
  actions: { setSavings },
  reducer: savingsReducer,
} = savingsSlice;
